import { render, staticRenderFns } from "./tablist.vue?vue&type=template&id=5f290f91&scoped=true&"
import script from "./tablist.vue?vue&type=script&lang=js&"
export * from "./tablist.vue?vue&type=script&lang=js&"
import style0 from "./tablist.vue?vue&type=style&index=0&id=5f290f91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f290f91",
  null
  
)

export default component.exports